<template>
	<div
		:aria-label="t('radioButtons')"
		class="radio-buttons"
	>
		<FormKit
			v-for="option in options"
			:key="option.value"
			type="button"
			:label="option.label"
			outer-class="max-w-full"
			:input-class="`
				w-full bg-white shadow-md text-gray-800 hover:bg-green-500/10 hover:border-green-500 border-2 rounded-md
				${option.value === modelValue ? 'border-green-500' : 'border-slate-100'}
			`"
			@click="handleClick(option.value)"
		/>
	</div>
</template>

<script setup lang="ts">
import { usePresentationLocale } from '@/i18n'

const { t } = usePresentationLocale()

const props = defineProps<{
	options: { label: string; value: string }[]
}>()

const modelValue = defineModel<string>()
const emit = defineEmits<{
	(e: 'update:modelValue', value: string): void
}>()

const handleClick = (option: string) => {
	emit('update:modelValue', option)
}
</script>

<style scoped>
@reference "tailwindcss";
.radio-buttons :deep(.formkit-input) {
	@apply py-12 pr-14 pl-4 text-2xl!;
}
</style>
